module.exports = __webpack_public_path__ + "static/default-blog-image-7a09013118082df2f156be046a30379f.jpeg";